export const didEntryMatchWinner = (winningSelections, entryId) => {
    if (!entryId) {
        return false;
    }
    return winningSelections.some(winner => winner.id && winner.id === entryId);
};

export default didEntryMatchWinner;
